import { App, type URLOpenListenerEvent } from '@capacitor/app'
import { Capacitor } from '@capacitor/core'
import router from '@/router'

export function setupDeepLinks(): void {
  if (!Capacitor.isNativePlatform()) return

  App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
    let path: string
    try {
      path = new URL(event.url).pathname
    } catch {
      return
    }

    if (path.startsWith('/invite/')) {
      router.push(path)
      return
    }

    // #4001 — `/tasks/:id` ya es una ruta real de la app, que resuelve sola a
    // qué tablero pertenece la tarea. Antes se traducía a `/my-tasks?task=`,
    // que solo abría las tareas sin proyecto.
    if (/^\/tasks\/[^/]+/.test(path)) {
      router.push(path)
      return
    }

    if (path.startsWith('/projects/')) {
      router.push(path)
      return
    }
  })
}
